'use es6';

import { apiProxyAllowList } from 'tinymce-config/Constants';
import cmv2ApiProxyWhitelist from 'ContentData/constants/apiProxyWhitelist';
import smartContentApiProxyWhitelist from 'smart-content-core/utils/apiProxyWhitelist';
export default apiProxyAllowList.concat(cmv2ApiProxyWhitelist).concat(smartContentApiProxyWhitelist);